module.exports = __webpack_public_path__ + "img/franciscalara.a30f53dc.jpg";